import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'
import { DEFAULT_PER_PAGE } from '@/core/lib/pagination'

import { userEndpoints } from './user.constants'
import type {
  TCreateUserRequest,
  TUpdateUserRequest,
  TUser,
} from './user.types'

export async function getUserList(): Promise<TUser[]> {
  // Detay/düzenleme sayfaları listeden id ile bulur (tekil GET ucu yok); tümünü çek.
  const res = await api.get<TResponse<TUser[]>>(userEndpoints.list, {
    params: { per_page: 100 },
  })
  return res.data.data
}

// Liste sayfası için sunucu-taraflı sayfalama. Arama backend `filters=name:<q>`
// (varsayılan `ilike`) üzerinden yapılır. Zarfın tamamı (data + meta) döner.
export async function getUserListPaged(
  page: number,
  query: string
): Promise<TResponse<TUser[]>> {
  const params: Record<string, string | number> = {
    page,
    per_page: DEFAULT_PER_PAGE,
  }
  if (query) params.filters = `name:${query}`
  const res = await api.get<TResponse<TUser[]>>(userEndpoints.list, { params })
  return res.data
}

export async function createUser(body: TCreateUserRequest): Promise<TUser> {
  const res = await api.post<TResponse<TUser>>(userEndpoints.create, body)
  return res.data.data
}

export async function updateUser(
  id: string,
  body: TUpdateUserRequest
): Promise<TUser> {
  const res = await api.patch<TResponse<TUser>>(userEndpoints.update(id), body)
  return res.data.data
}
